import { OurNode } from "@src/cloud-connect/poc/our-node";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";

export const useCaretOurNodeMachineHook = () => {
  const handleCaretClick = (node: OurNode) => {
    const nodeManager = getNodeManager();

    nodeManager.getMachineCaretClickHandler().toggleExpanded(node);
  };

  return {
    handleCaretClick: handleCaretClick,
  };
};
